/*! Copyright (c) Safe As Milk. All rights reserved. */
class RecentSearches extends HTMLElement {
    constructor() {
        super();
        this.update();
    }
    update() {
        const recentSearchesStoredString = localStorage.getItem("recentSearches");
        if (!recentSearchesStoredString) return;
        const ul = this.querySelector("ul");
        if (!ul) return;
        let recentSearchesStored;
        try {
            recentSearchesStored = JSON.parse(recentSearchesStoredString);
        } catch (e) {
            return;
        }
        if (!Array.isArray(recentSearchesStored) || recentSearchesStored.length === 0) return;
        this.parentElement.classList.add("has-recent-searches");
        // El termino (`query`) y la URL (`uri`) provienen del parametro `q` del usuario.
        // Se construye el DOM con createElement + textContent en lugar de innerHTML y se
        // valida la URL a una ruta relativa del mismo origen: asi el termino se trata
        // SIEMPRE como texto (output-encoding por contexto) y se evita el DOM-XSS (CWE-79).
        ul.textContent = "";
        recentSearchesStored.reverse().forEach((item) => {
            if (!item) return;
            const li = document.createElement("li");
            li.className = "search__nav-item";
            const a = document.createElement("a");
            a.className = "search__nav-link";
            a.setAttribute("href", this.getSafeUri(item.uri));
            a.textContent = item.query == null ? "" : String(item.query);
            li.appendChild(a);
            ul.appendChild(li);
        });
        this.removeAttribute("hidden");
    }
    getSafeUri(uri) {
        // Solo se permiten rutas relativas del mismo origen; bloquea javascript:, data:,
        // //host y http(s) hacia otro dominio. Ante cualquier duda, cae a "/search".
        try {
            const parsed = new URL(String(uri == null ? "" : uri), window.location.origin);
            if (parsed.origin !== window.location.origin) return "/search";
            return parsed.pathname + parsed.search;
        } catch (e) {
            return "/search";
        }
    }
}

customElements.define("recent-searches", RecentSearches);
